import { searchCountries, toCountryOption } from '~/helpers/country-helper';

export default async (axios, searchValue, page, limit, params = {}) => {
    const content = searchCountries(searchValue);

    return {
        metadata: {
            page: 1,
            pages: 1,
        },
        result: content.map(toCountryOption),
    };
};
